enum SourceEntryPoint {
    Settings = 0,
    MailComposeToolbar = 1,
    CalendarComposeToolbar = 2,
}

export default SourceEntryPoint;
